<template>
  <section>
    <qx-img-dialog ref="imgDialog" />
    <EditDialog ref="editDialog" @sub="handleEditSub" :orgId="orgId" />
    <ChooseAnnualFee
      :otherSearchData="{
        costType: 2005,
        orgId,
      }"
      ref="chooseAnnualFee"
      :customShow="true"
      @change="handleEditSub"
    />
    <span class="primary cur addBtn" @click="showEdit()">添加</span>
    <span class="primary cur" @click="showChoose()">选择</span>
    <!-- 表格 -->
    <section class="tableBox" v-show="resultVal.length !== 0">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="resultVal"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        >
          <section slot-scope="scope">
            <section v-if="scope.column.property === 'detailPic'">
              <span
                class="primary cur"
                v-for="(item, index) in scope.row.detailPic"
                style="margin-right: 8px;"
                :key="index"
                @click="previewImg(item.url)"
              >{{'附件' + (index+1)}}</span>
            </section>
            <section
              v-if="scope.column.property !== 'detailPic'"
            >{{scope.row[scope.column.property]}}</section>
          </section>
        </el-table-column>
        <!-- 常规列表项 end -->
        <!-- 操作按钮 -->
        <el-table-column prop="control" label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <section>
              <!-- 操作按钮 -->
              <qx-permpisions permpisions>
                <span class="primary cur" @click="showEdit(scope.row)" v-show="!scope.row.id">修改</span>
              </qx-permpisions>
              <qx-permpisions permpisions>
                <span class="primary cur" @click="del(scope.row)">删除</span>
              </qx-permpisions>
              <!-- 操作按钮 end -->
            </section>
          </template>
        </el-table-column>
        <!-- 操按钮 end -->
      </el-table>
    </section>
    <!-- 表格 end -->
  </section>
</template>

<script>
import EditDialog from './editDialog';
import ChooseAnnualFee from 'components/choose/annualFee';
export default {
  components: {
    EditDialog,
    ChooseAnnualFee,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    resultVal: {
      type: Array,
      default: () => ([]),
    },
    orgId: {
      type: Number,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'certificatesInsuranceTypeName',
            label: '年审类型',
          },
          {
            prop: 'payAmt',
            label: '年审费用（元）',
          },
          {
            prop: 'insuranceStartDate',
            label: '年审日期',
          },
          {
            prop: 'insuranceEndDate',
            label: '截止有效日期',
          },
          {
            prop: 'detailPic',
            label: '附件',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    showEdit (item) {
      this.$refs.editDialog.show(item);
    },
    showChoose () {
      if (!this.orgId) {
        this.$message.warning('请先选择费用归属');
        return;
      }
      this.$refs.chooseAnnualFee.show();
    },
    handleEditSub (chooseVal) {
      if (!chooseVal.form) { // 选择
        const chooseValIds = chooseVal.map((item) => item.id);
        const resultValIds = this.resultVal.map((item) => item.id);
        chooseVal.forEach((d) => {
          if (resultValIds.indexOf(d.id) === -1) {
            d.payAmt = d.certificatesInsuranceFee / 100;
            d.busiType = d.certificatesInsuranceType;
            this.resultVal.push(d);
          }
        });
        resultValIds.forEach((id, index) => {
          if (id && chooseValIds.indexOf(id) === -1) {
            this.resultVal.splice(index, 1);
          }
        });
      } else if (chooseVal.originData) { // 修改
        const index = this.resultVal.indexOf(chooseVal.originData);
        this.resultVal.splice(index, 1, chooseVal.form);
      } else { // 新增
        this.resultVal.push(chooseVal.form);
      }
      this.$emit('change', this.resultVal);
    },
    previewImg (url) {
      this.$refs.imgDialog.show(url);
    },
    del (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('change', this.resultVal);
    },
  },
};
</script>

<style scoped lang="scss">
.addBtn {
  margin-right: 16px;
}
</style>
